import React, { useEffect, useRef, useState } from "react";
import enhancedWebswitcherIMG1 from "@frameworks/web/assets/images/generic/enhancedWebswitcherIMG1.svg";
import enhancedWebswitcherIMG2 from "@frameworks/web/assets/images/generic/enhancedWebswitcherIMG2.svg";
import enhancedWebswitcherIMG3 from "@frameworks/web/assets/images/generic/enhancedWebswitcherIMG3.svg";
import enhancedWebswitcherIMG4 from "@frameworks/web/assets/images/generic/enhancedWebswitcherIMG4.svg";
import enhancedWebswitcherIMG5 from "@frameworks/web/assets/images/generic/enhancedWebswitcherIMG5.svg";
import EdButton, { EdButtonIcon, } from "@frameworks/web/components/generic/edbutton/edButton";
import "@frameworks/web/stylesheets/components/Reports/SwitchToEnhancedReports.scss";
import Edelicon from "@frameworks/web/components/generic/Edelicon";
import * as URLConfig from "@frameworks/web/config/domain";
const SwitchToNewReports = (props) => {
    const config = URLConfig.config;
    const contentRef = useRef(null);
    const [slideIndex, setSlideIndex] = useState(0);
    const [stopAutoSlide, setStopAutoSlide] = useState(false);
    const scrollToIndex = (index) => {
        setSlideIndex(index);
        const elements = document.querySelectorAll(".enhance-feature");
        if (elements && elements[index]) {
            elements[index].scrollIntoView({ behavior: "smooth", inline: "start" });
        }
    };
    const enhancedFeatures = [
        {
            subTitle: React.createElement(React.Fragment, null, "You\u2019re Invited! Get an Early Look at Our New Website"),
            tagText: "Exclusively for You",
            tagColor: "#CDFFE4",
            img: enhancedWebswitcherIMG1,
        },
        {
            subTitle: (React.createElement(React.Fragment, null,
                "Track Your Favourites in ",
                React.createElement("br", null),
                "One Place")),
            tagText: "All-new watchlist",
            tagColor: "#CDFFE4",
            img: enhancedWebswitcherIMG2,
        },
        {
            subTitle: (React.createElement(React.Fragment, null,
                "Seamlessly Discover ",
                React.createElement("br", null),
                "What Matters")),
            tagText: "Improved Search",
            tagColor: "#CDEFFF",
            img: enhancedWebswitcherIMG3,
        },
        {
            subTitle: (React.createElement(React.Fragment, null,
                "Get Detailed Insights at a ",
                React.createElement("br", null),
                "Glance")),
            tagText: "Enhanced Quotes",
            tagColor: "#FEDCF4",
            img: enhancedWebswitcherIMG4,
        },
        {
            subTitle: (React.createElement(React.Fragment, null,
                "Track Your Holdings and ",
                React.createElement("br", null),
                "Positions with Ease")),
            tagText: "Advanced Reporting",
            tagColor: "#FFDFC2",
            img: enhancedWebswitcherIMG5,
        },
    ];
    const navigateToNewWebsite = () => {
        localStorage.setItem("prefered_site", "new");
        window.location.replace(config.newWebUrl);
    };
    useEffect(() => {
        //for auto sliding
        if (stopAutoSlide)
            return;
        const next = (slideIndex + 1) % enhancedFeatures.length;
        const timeout = setTimeout(() => {
            scrollToIndex(next);
        }, 3000);
        return () => clearTimeout(timeout);
    }, [slideIndex, stopAutoSlide]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "switch-to-enhance-report-backdrop" }),
        React.createElement("div", { className: "switch-to-enhance-report" },
            React.createElement("div", { className: "carousal-container " },
                React.createElement(EdButtonIcon, { btnIcon: "edel-icon-cross-bold-small", btnTyp: "grey-suit", className: "close-switcher", onClick: () => props === null || props === void 0 ? void 0 : props.setOpenSwitcher(false) }),
                React.createElement("span", { className: "switcher-title" }, "Try the New Website"),
                React.createElement("div", { className: "enhanced-featurelist", ref: contentRef }, enhancedFeatures === null || enhancedFeatures === void 0 ? void 0 : enhancedFeatures.map((data) => {
                    return (React.createElement("div", { className: "enhance-feature", onMouseEnter: () => setStopAutoSlide(true), onMouseOut: () => setStopAutoSlide(false) },
                        React.createElement("div", { className: "sub-title-section" },
                            data.subTitle,
                            "\u00A0",
                            React.createElement("span", { className: "enhanced-feature-tag", style: { background: data.tagColor } }, data.tagText)),
                        React.createElement("img", { className: "enhanced-feature-bg-img", src: data.img, alt: "slide" })));
                })),
                React.createElement("div", { className: "navigation-buttons" },
                    React.createElement("div", { className: "sliding-navigations" },
                        React.createElement(Edelicon, { className: `edel-icon-arrow-left1  ${slideIndex === 0 ? "opacity-50" : "hand_cursor"}`, onClick: () => {
                                if (slideIndex > 0)
                                    scrollToIndex(slideIndex - 1);
                            } }),
                        React.createElement("div", { className: "slider-dots" }, enhancedFeatures === null || enhancedFeatures === void 0 ? void 0 : enhancedFeatures.map((dot, index) => (React.createElement("span", { className: `inner-dot ${index + 1 === slideIndex + 1 ? "active" : ""}`, onClick: () => scrollToIndex(index) })))),
                        React.createElement(Edelicon, { className: `edel-icon-arrow-right1 ${slideIndex === (enhancedFeatures === null || enhancedFeatures === void 0 ? void 0 : enhancedFeatures.length) - 1
                                ? "opacity-50"
                                : "hand_cursor"}`, onClick: () => {
                                if (slideIndex < (enhancedFeatures === null || enhancedFeatures === void 0 ? void 0 : enhancedFeatures.length) - 1)
                                    scrollToIndex(slideIndex + 1);
                            } })),
                    React.createElement(EdButton, { value: "See it first!", btnTyp: "tomato-red", type: "button", className: "see-it-firstbtn", onClick: () => navigateToNewWebsite() }))))));
};
const SwitchToEnhancedReports = () => {
    const [openSwitcher, setOpenSwitcher] = useState(false);
    useEffect(() => {
        const timeout = setTimeout(() => {
            setOpenSwitcher(true);
        }, 3000);
        return () => clearTimeout(timeout);
    }, []);
    if (!openSwitcher)
        return React.createElement(React.Fragment, null);
    return React.createElement(SwitchToNewReports, { setOpenSwitcher: setOpenSwitcher });
};
export default SwitchToEnhancedReports;
